import { LoadingButton } from '@mui/lab';
import { Box, DialogTitle, FormControl, TextField } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import useEditCellNode from 'api/locationsCategories/useEditCellNode';
import { useForm } from 'react-hook-form';

import { cellFieldValidationValues } from '../constants';

const EditCellNodeModal = props => {
  const { guid, defaultName } = props;

  const [editLoading, editCellNode] = useEditCellNode();

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors, isSubmitted },
  } = useForm({
    defaultValues: {
      name: defaultName || '',
    },
  });

  const onSubmit = data => {
    editCellNode(
      guid,
      {
        name: data.name,
      },
      props.refreshData,
    );
  };

  const handleClose = () => {
    props.closeHandler();
    reset({
      name: defaultName || '',
    });
  };

  return (
    <Dialog
      open={props.show}
      onClose={handleClose}
      sx={{ direction: 'rtl' }}
      onKeyDown={e => {
        if (e.key === 'Enter') {
          handleSubmit(onSubmit)();
        }
      }}
    >
      <DialogTitle>ویرایش سلول</DialogTitle>

      <DialogContent>
        <Box sx={{ width: 320 }}>
          <FormControl sx={{ m: 1, minWidth: 300 }}>
            <TextField
              autoFocus
              label="عنوان سلول"
              variant="standard"
              {...register('name', cellFieldValidationValues)}
              error={isSubmitted ? !!errors.name : false}
              helperText={errors.name?.message || ''}
            />
          </FormControl>
        </Box>
      </DialogContent>

      <DialogActions sx={{ gap: 1, padding: 3 }}>
        <LoadingButton
          variant="contained"
          color="primary"
          loading={editLoading}
          onClick={handleSubmit(onSubmit)}
        >
          تایید
        </LoadingButton>

        <LoadingButton
          variant="contained"
          color="warning"
          loading={editLoading}
          onClick={handleClose}
        >
          انصراف
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};

export default EditCellNodeModal;
